import React from 'react';
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
import Button from 'common/components/Button';
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
import { ButtonSchema, ButtonSize } from 'common/components/Button/constants';
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
import { useTranslateFn } from 'utils/useTranslateFn';
import styles from './styles.module.scss';

interface IGroupManagementBlockProps {
  onAddToGroup: () => void;
  onAddAndBuildAnother: () => void;
  onStartOver: () => void;
  isEditing: boolean;
  isAtLimit: boolean;
  isAdding?: boolean;
  isCompleted?: boolean;
}


// eslint-disable-next-line no-unused-vars
const GroupManagementBlock = ({
  onAddToGroup, // eslint-disable-line no-unused-vars
  onAddAndBuildAnother, // eslint-disable-line no-unused-vars
  onStartOver, // eslint-disable-line no-unused-vars
  isEditing, // eslint-disable-line no-unused-vars
  isAtLimit, // eslint-disable-line no-unused-vars
  isAdding = false, // eslint-disable-line no-unused-vars
  isCompleted = false, // eslint-disable-line no-unused-vars
}: IGroupManagementBlockProps) => {
  const t = useTranslateFn<string>(); // eslint-disable-line no-unused-vars, @typescript-eslint/no-unused-vars

  return (
    <div className={styles.groupManagement}>
      {/* Temporarily hidden: Add to Group button
      <Button
        schema={ButtonSchema.secondary}
        size={ButtonSize.standard}
        onClick={onAddToGroup}
        disabled={isAdding || isCompleted}
      >
        <span className={styles.buttonIconPlus}>&#x2b;</span>
        <span className={styles.buttonLabel}>
          {isEditing
            ? t('texts.assemblyGroup.updateButton')
            : t('texts.assemblyGroup.addButton')}
        </span>
      </Button>
      */}
      {/* Temporarily hidden: Save & Build Another — moved to footer
      <Button
        schema={ButtonSchema.secondary}
        size={ButtonSize.standard}
        onClick={onAddAndBuildAnother}
        disabled={isAtLimit || isAdding || isCompleted}
      >
        <span className={styles.buttonIcon}>&#x27f3;</span>
        <span className={styles.buttonLabel}>{t('texts.assemblyGroup.addGroupBuildAnother')}</span>
      </Button>
      */}
      {/* Temporarily hidden: Start Over button
      <Button
        schema={ButtonSchema.secondary}
        size={ButtonSize.standard}
        onClick={onStartOver}
      >
        <span className={styles.buttonIconSmall}>&#x2715;</span>
        <span className={styles.buttonLabel}>{t('texts.assemblyGroup.startOver')}</span>
      </Button>
      */}
    </div>
  );
};

export default GroupManagementBlock;
